/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import {Text} from 'wix-ui-tpa/cssVars';
import s from './FiltersHeader.scss';
import {X} from '../../../../icons/dist';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {withGlobals} from '../../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../galleryGlobalStrategy';
import classNames from 'classnames';
import {ProductsCounter} from '../../../../common/components/ProductsCounter/ProductsCounter';
import {ConditionalRender} from '../../../../common/components/ConditionalRender/ConditionalRender';
import {Experiments} from '../../../../constants';
import {MobileFiltersAndSortButtonText} from '../../../../common/components/MobileFiltersAndSort/MobileFiltersAndSortButtonText/MobileFiltersAndSortButtonText';

export interface IFiltersHeaderProps extends IGalleryGlobalProps, IProvidedTranslationProps {
  combineFiltersAndSort?: boolean;
  modalHeaderId?: string;
}

export enum FiltersHeaderDataHooks {
  Root = 'filters-header',
  Title = 'filters-title',
  Cancel = 'cancel',
}

export class FiltersHeaderComp extends React.Component<IFiltersHeaderProps> {
  public render() {
    const {shouldShowMobile, usingExtendedGridGalleryStyles, applyFilteredProductsOnMobile, useExperiments} =
      this.props.globals;
    const isSplitDesignTitlesEnabled = useExperiments.enabled(Experiments.GallerySplitDesignTitlesViewer);
    const {combineFiltersAndSort} = this.props;
    const htmlTag = this.props.globals.htmlTags.categoriesFiltersHtmlTag;
    const renderFilterHeaderText = () => {
      return (
        <>
          {combineFiltersAndSort ? <MobileFiltersAndSortButtonText /> : this.props.t('filtersTitleText')}
          {shouldShowMobile && usingExtendedGridGalleryStyles && (
            <>
              <span>&nbsp;</span>
              <ProductsCounter mobileInlineMode={true} />
            </>
          )}
        </>
      );
    };

    return (
      <ConditionalRender
        by="shouldRenderFiltersHeader"
        dataHook={FiltersHeaderDataHooks.Root}
        className={classNames(s.header, {
          [s.usingExtendedGridGalleryStyles]: usingExtendedGridGalleryStyles,
        })}>
        <ConditionalRender
          by={'gallery_showFiltersTitle'}
          className={classNames({
            [s.overflowHidden]: true,
          })}>
          <Text
            tagName={htmlTag}
            data-hook={FiltersHeaderDataHooks.Title}
            className={classNames(s.title, {
              [s.usingExtendedGridGalleryStyles]: usingExtendedGridGalleryStyles,
              [s.oldFiltersTitleFontAndColor]: !isSplitDesignTitlesEnabled,
            })}
            id={this.props.modalHeaderId}>
            {renderFilterHeaderText()}
          </Text>
        </ConditionalRender>
        {shouldShowMobile && (
          <button
            type="button"
            data-hook={FiltersHeaderDataHooks.Cancel}
            aria-label={this.props.t('filtersAriaLabel')}
            className={s.cancel}
            onClick={() => applyFilteredProductsOnMobile()}>
            <X />
          </button>
        )}
      </ConditionalRender>
    );
  }
}

export const FiltersHeader = withGlobals(withTranslations()(FiltersHeaderComp));
